import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.MANAGEMENT_AND_ORGANIZATION}.${BUSINESS_TOOL_SUB_SECTIONS.MANAGEMENT_AND_ORGANIZATION.STAFF_ORGANIZATION}` as const;

export const LEVEL3_DEPARTMENT_NAMES = {
  DEPARTMENT: 'department',
  BELOW_DEPARTMENT: 'belowDepartment',
} as const;

export interface ILevel3Department {
  [LEVEL3_DEPARTMENT_NAMES.DEPARTMENT]: string;
  [LEVEL3_DEPARTMENT_NAMES.BELOW_DEPARTMENT]: string;
}

export const level3DepartmentValues = {
  [LEVEL3_DEPARTMENT_NAMES.DEPARTMENT]: '',
  [LEVEL3_DEPARTMENT_NAMES.BELOW_DEPARTMENT]: '',
};

export const LEVEL2_DEPARTMENT_NAMES = {
  DEPARTMENT: 'department',
} as const;

export interface ILevel2Department {
  [LEVEL2_DEPARTMENT_NAMES.DEPARTMENT]: string;
}

export const level2DepartmentValues = {
  [LEVEL2_DEPARTMENT_NAMES.DEPARTMENT]: '',
};

export const STAFF_ORGANIZATION_NAMES = {
  NUMBER_OF_STAFF: 'numberOfStaff',
  LEVEL1_DEPARTMENT: 'level1Department',
  LEVEL2_DEPARTMENT: 'level2Department',
  LEVEL3_DEPARTMENT: 'level3Department',
  SKILLS: 'skills',
  ADDITIONAL_HIRES: 'additionalHires',
  APPROACHES: 'approaches',
  ATTRACTING_DIFFICULTIES: 'attractingDifficulties',
  SALARY_POLICY: 'salaryPolicy',
  RETENTION_DIFFICULTIES: 'retentionDifficulties',
  DEVELOPMENT_PROGRAMS: 'developmentPrograms',
} as const;

export interface IStaffOrganization {
  [STAFF_ORGANIZATION_NAMES.NUMBER_OF_STAFF]: string;
  [STAFF_ORGANIZATION_NAMES.LEVEL1_DEPARTMENT]: string;
  [STAFF_ORGANIZATION_NAMES.LEVEL2_DEPARTMENT]: ILevel2Department[];
  [STAFF_ORGANIZATION_NAMES.LEVEL3_DEPARTMENT]?: ILevel3Department[];
  [STAFF_ORGANIZATION_NAMES.SKILLS]: string;
  [STAFF_ORGANIZATION_NAMES.ADDITIONAL_HIRES]: string;
  [STAFF_ORGANIZATION_NAMES.APPROACHES]: string;
  [STAFF_ORGANIZATION_NAMES.ATTRACTING_DIFFICULTIES]: string;
  [STAFF_ORGANIZATION_NAMES.SALARY_POLICY]: string;
  [STAFF_ORGANIZATION_NAMES.RETENTION_DIFFICULTIES]: string;
  [STAFF_ORGANIZATION_NAMES.DEVELOPMENT_PROGRAMS]: string;
}

export const staffOrganizationInitialValues: IStaffOrganization = {
  [STAFF_ORGANIZATION_NAMES.NUMBER_OF_STAFF]: '',
  [STAFF_ORGANIZATION_NAMES.LEVEL1_DEPARTMENT]: '',
  [STAFF_ORGANIZATION_NAMES.LEVEL2_DEPARTMENT]: [level2DepartmentValues],
  [STAFF_ORGANIZATION_NAMES.LEVEL3_DEPARTMENT]: [level3DepartmentValues],
  [STAFF_ORGANIZATION_NAMES.SKILLS]: '',
  [STAFF_ORGANIZATION_NAMES.ADDITIONAL_HIRES]: '',
  [STAFF_ORGANIZATION_NAMES.APPROACHES]: '',
  [STAFF_ORGANIZATION_NAMES.ATTRACTING_DIFFICULTIES]: '',
  [STAFF_ORGANIZATION_NAMES.SALARY_POLICY]: '',
  [STAFF_ORGANIZATION_NAMES.RETENTION_DIFFICULTIES]: '',
  [STAFF_ORGANIZATION_NAMES.DEVELOPMENT_PROGRAMS]: '',
};
